import { TrackingFunction } from "@webng/liveblog";
import { useChangeBridgeContext } from "@webng/liveblog/src/change-stream/useChangeBridge";
import { useCallback, useEffect, useState } from "react";

export function useVersions(trackingFunction: TrackingFunction) {
  const changeBridgeValue = useChangeBridgeContext();
  
  if(!changeBridgeValue) {
    throw new Error("ChangeBridgeContext not found");
  }

  const { ws, liveblogLocalId, hasErrored } = changeBridgeValue;

  const [version, setVersion] = useState<number | undefined>(undefined);

  const onOpen = useCallback(() => {
    trackingFunction({ t: "w_con", url: liveblogLocalId })
  }, [trackingFunction, liveblogLocalId]);

  const onMessage = useCallback((event: MessageEvent) => {
    const message = JSON.parse(event.data);
    if (message.type === "version") {
      setVersion(message.version);
    }
  }, [setVersion]);

  const onClose = useCallback(() => {
    trackingFunction({ t: "w_dis", s: 1000, url: liveblogLocalId })
  }, [trackingFunction, liveblogLocalId]);

  const onError = useCallback((event: Event) => {
    trackingFunction({ t: "w_err", s: 4002, url: liveblogLocalId })
  }, [trackingFunction, liveblogLocalId]);

  useEffect(() => {
    if (!ws) {
      return;
    }

    ws.addEventListener("open", onOpen);
    ws.addEventListener("message", onMessage);
    ws.addEventListener("close", onClose);
    ws.addEventListener("error", onError);

    return () => {
      ws.removeEventListener("open", onOpen);
      ws.removeEventListener("message", onMessage);
      ws.removeEventListener("close", onClose);
      ws.removeEventListener("error", onError);
    };
  }, [ws, onOpen, onMessage, onClose, onError]);

  if(hasErrored) {
    return undefined;
  }

  return version;
}